import React from "react";
import CircularProgress from "@mui/material/CircularProgress";
import axios from "axios";
import { useNavigate } from "react-router-dom";

export default function LoginCallback() {
  var code = null;
  const navigate = useNavigate();

  window.onload = async function () {
    const urlParams = new URLSearchParams(window.location.search.substring(1));
    code = urlParams.get("code");

    await getUserDetail();
  };

  async function getUserDetail() {
    var data = null;

    await axios
      .post(`${process.env.REACT_APP_BASE_URL}/login`, { code, sso: "google"})
      .then((response) => {
        data = response.data;

        if (data.status === true) {
          localStorage.setItem("token", data.token);

          navigate("/token-gating", { replace: true });
        } else if (data.status === false) {
          navigate("/");
        }
      })
      .catch((err) => {
        navigate("/");
      });
  }

  return (
    <div style={{ marginTop: "20%", textAlign: "center" }}>
      <CircularProgress style={{ color: "rgb(0, 89, 63)" }} />
    </div>
  );
}
